import React from "react";

/**
 * The Header is simply the main heading of the application,
 * no props... just a static file.
 */
const Header = () => {
  return (
    <header className="header">
      <h1>Retro Draw</h1>
    </header>
  );
};

export default Header;
